




































































































// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { bookingModule } from '@/store';
import { Airline, Flight } from '@/api';
import RelAutocomplete from '@/components/RelAutocomplete.vue';
import RelSelect from '@/components/RelSelect.vue';
import TimePicker from '@/components/TimePicker.vue';

@Component({
  components: {
    RelAutocomplete,
    RelSelect,
    TimePicker,
  },
})
export default class extends Vue {
  loading: boolean = false;
  valid: boolean = false;
  invalidDatetime: boolean = false;

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  requiredNumber = [
    (v: string) =>
      v8n()
        .number()
        .greaterThan(0)
        .test(Number(v)) || 'Must be a number greater than 0',
  ];

  requiredObject = [
    (v: Airline | Flight) => {
      if (!v) {
        return 'This field is required';
      }

      return (
        v8n()
          .string()
          .not.empty()
          .test(v.id) || 'This field is required'
      );
    },
  ];

  requiredFlightOut = [
    (v: Flight) => {
      if (!v) {
        return 'This field is required';
      }

      return (
        v8n()
          .string()
          .not.empty()
          .test(v.id) || 'This field is required'
      );
    },
  ];
  requiredFlightIn = [
    (v: Flight) => {
      if (!v) {
        return 'This field is required';
      }

      return (
        v8n()
          .string()
          .not.empty()
          .test(v.id) || 'This field is required'
      );
    },
  ];

  requiredCheckbox = [
    (v: boolean) => {
      return (
        v8n()
          .boolean()
          .equal(true)
          .test(v) || 'This field is required'
      );
    },
  ];

  get booking() {
    if (!bookingModule.booking) {
      return;
    }
    return bookingModule.booking;
  }

  get flightNumberOut() {
    if (!bookingModule.flightNumberOut) {
      return null;
    }
    return bookingModule.flightNumberOut;
  }
  set flightNumberOut(flight: Flight | null) {
    bookingModule.setFlightNumberOut(flight);
  }

  get flightNumberOutText() {
    if (!bookingModule.flightNumberOutText) {
      return '';
    }
    return bookingModule.flightNumberOutText;
  }
  set flightNumberOutText(flight: string) {
    bookingModule.setFlightNumberOutText(flight);
  }

  get flightNumberIn() {
    if (!bookingModule.flightNumberIn) {
      return null;
    }
    return bookingModule.flightNumberIn;
  }
  set flightNumberIn(flight: Flight | null) {
    bookingModule.setFlightNumberIn(flight);
  }

  get flightNumberInText() {
    if (!bookingModule.flightNumberInText) {
      return '';
    }
    return bookingModule.flightNumberInText;
  }
  set flightNumberInText(flight: string) {
    bookingModule.setFlightNumberInText(flight);
  }

  get departureDate() {
    if (!bookingModule.startDate) {
      return;
    }
    return moment(bookingModule.startDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }

  get departureTime() {
    if (!bookingModule.departureTime) {
      return '';
    }
    return bookingModule.departureTime;
  }
  set departureTime(time: string) {
    bookingModule.setDepartureTime(time);
  }

  get returnTime() {
    if (!bookingModule.returnTime) {
      return '';
    }
    return bookingModule.returnTime;
  }
  set returnTime(time: string) {
    bookingModule.setReturnTime(time);
  }

  get depatureConfirm() {
    if (!bookingModule.depatureConfirm) {
      return false;
    }
    return bookingModule.depatureConfirm;
  }
  set depatureConfirm(confirm: boolean) {
    bookingModule.setDepatureConfirm(confirm);
  }

  get customBusTime() {
    if (!this.departureTime) {
      return;
    }
    return moment(this.departureTime, 'HH:mm')
      .subtract(1, 'hours')
      .format('HH:mm');
  }

  get returnDate() {
    if (!bookingModule.endDate) {
      return;
    }
    return moment(bookingModule.endDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }

  get service() {
    if (!bookingModule.startDate) {
      return;
    }

    const day = moment(bookingModule.startDate, 'YYYY-MM-DD').weekday();
    if (day === 0 || day === 6) {
      return 'weekend';
    } else {
      return 'weekday';
    }
  }

  airlineScopeFactory() {
    return Airline.includes([]);
  }

  flightOutScopeFactory() {
    return Flight.where({ departure: true })
      .order({ time: 'asc' })
      .includes(['busTrip']);
  }
  flightInScopeFactory() {
    return Flight.where({ departure: false }).order({ time: 'asc' });
  }

  get flightOutWhere() {
    if (!this.booking || !this.booking.airlineOut) {
      return;
    }
    return { airline: this.booking.airlineOut.id, service: this.service };
  }

  get flightInWhere() {
    if (!this.booking || !this.booking.airlineIn) {
      return;
    }
    return { airline: this.booking.airlineIn.id, service: this.service };
  }

  get notFlyingOut() {
    if (!this.booking || !this.booking.airlineOut) {
      return false;
    }
    return this.booking.airlineOut.name === 'Not flying';
  }

  get notFlyingIn() {
    if (!this.booking || !this.booking.airlineIn) {
      return false;
    }
    return this.booking.airlineIn.name === 'Not flying';
  }

  bookingBack() {
    this.$router.back();
  }

  cocatMoment(date: string, time: string): string {
    return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').toISOString();
  }

  step4() {
    if (!this.booking) {
      return;
    }

    if (this.flightNumberOut && this.flightNumberOut.id !== '0') {
      this.booking.flightNumberOut = this.flightNumberOut.flightNumber;
    } else if (this.flightNumberOut && this.flightNumberOut.id === '0') {
      this.booking.flightNumberOut = this.flightNumberOutText;
    }

    let departureTime = '';
    if (this.flightNumberOut) {
      if (this.flightNumberOut.id === '0') {
        departureTime = this.departureTime;
        this.booking.busDepartureTime = this.customBusTime || null;
      } else {
        departureTime = this.flightNumberOut.time;

        if (this.flightNumberOut.busTrip) {
          this.booking.busDepartureTime = this.flightNumberOut.busTrip.departureTime;
        }
      }
    } else if (this.notFlyingOut) {
      departureTime = this.departureTime;
      this.booking.busDepartureTime = null;
    }

    if (bookingModule.startDate && departureTime) {
      this.booking.startDatetime = this.cocatMoment(bookingModule.startDate, departureTime);
    }

    if (this.flightNumberIn && this.flightNumberIn.id !== '0') {
      this.booking.flightNumberIn = this.flightNumberIn.flightNumber;
    } else if (this.flightNumberIn && this.flightNumberIn.id === '0') {
      this.booking.flightNumberIn = this.flightNumberInText;
    }

    let returnTime = '';
    if (this.flightNumberIn) {
      if (this.flightNumberIn.id === '0') {
        returnTime = this.returnTime;
      } else {
        returnTime = this.flightNumberIn.time;
      }
    } else if (this.notFlyingIn) {
      returnTime = this.returnTime;
    }

    if (bookingModule.endDate && returnTime) {
      this.booking.endDatetime = this.cocatMoment(bookingModule.endDate, returnTime);
    }

    // Ensure startDatetime is before endDatetime
    this.invalidDatetime = moment(this.booking.endDatetime)
      .diff(moment(this.booking.startDatetime), 'minutes') <= 0
    if (this.invalidDatetime) return;

    bookingModule.setCompletedStep(4);

    this.$router.push({
      name: 'booking-step-5',
    });
  }

  mounted() {
    bookingModule.setCurrentStep(4);
    bookingModule.checkStatus();
  }

  @Watch('booking.airlineOut')
  airlineOutChanged(val: Airline, oldVal: Airline) {
    if (oldVal && val && oldVal.id !== val.id) {
      this.flightNumberOut = null;
    }
  }

  @Watch('booking.airlineIn')
  airlineInChanged(val: Airline, oldVal: Airline) {
    if (oldVal && val && oldVal.id !== val.id) {
      this.flightNumberIn = null;
    }
  }
}
